// エラートースト（store/alert の setError → components/util/Alert.vue）を出す。
// 旧 window.alert() はブロッキングで、連続したエラーでも1回ずつしか出なかった。
// トーストは連発できてしまうので、同じメッセージは短時間（ERROR_TOAST_DEDUPE_MS）に1回だけ出す。
export const ERROR_TOAST_DEDUPE_MS = 3000

let last = { message: null, at: -Infinity }

// 出したら true、重複で抑えた・store が無いなら false
export const notifyError = (store, message, { now = Date.now() } = {}) => {
  if (!store || !message) return false
  if (last.message === message && now - last.at < ERROR_TOAST_DEDUPE_MS)
    return false
  last = { message, at: now }
  store.commit('alert/setError', message)
  return true
}

// テスト用
export const resetErrorToast = () => {
  last = { message: null, at: -Infinity }
}
